import React, { useEffect, useRef, useState } from "react";
import { Bookmark, Copy } from "lucide-react";
import { Button } from "./ui/button";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle,
} from "./ui/dialog";
import { bookmarkletCode } from "../api";
import { toast } from "../hooks/use-toast";

export default function BankBookmarklet() {
  const [open, setOpen] = useState(false);
  const linkRef = useRef(null);

  useEffect(() => {
    if (open) setTimeout(() => linkRef.current?.setAttribute("href", bookmarkletCode), 0);
  }, [open]);

  const copy = () => {
    navigator.clipboard?.writeText(bookmarkletCode);
    toast({ title: "Código do favorito copiado" });
  };

  return (
    <>
      <Button data-testid="bookmarklet-open-btn" variant="outline" onClick={() => setOpen(true)} className="border-slate-200 text-[#0A1B6B]">
        <Bookmark className="mr-2 h-4 w-4" /> Favorito "Preencher BB"
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-lg">
          <DialogHeader>
            <DialogTitle className="font-heading text-[#0A1B6B]">Instalar o favorito "Preencher BB"</DialogTitle>
          </DialogHeader>
          <div className="space-y-4 text-sm text-slate-600">
            <p>Faça isso só uma vez, no computador (Chrome ou Edge).</p>
            <ol className="list-decimal space-y-2 pl-5">
              <li>Mostre a barra de favoritos: <b>Ctrl + Shift + B</b> (no Mac, <b>Cmd + Shift + B</b>).</li>
              <li>Arraste o botão amarelo abaixo até a barra de favoritos.</li>
            </ol>
            <div className="flex justify-center py-2">
              <a
                ref={linkRef}
                data-testid="bookmarklet-drag-link"
                onClick={(e) => { e.preventDefault(); toast({ title: "Arraste este botão para a barra de favoritos" }); }}
                className="cursor-grab rounded-full bg-[#FCFC30] px-6 py-3 font-heading font-extrabold text-[#0A1B6B] shadow-md"
              >
                Preencher BB
              </a>
            </div>
            <p className="text-xs text-slate-400">
              Se não conseguir arrastar: crie um favorito qualquer, edite-o e cole este código no campo do endereço (URL).
            </p>
            <Button data-testid="bookmarklet-copy-btn" variant="outline" onClick={copy} className="w-full">
              <Copy className="mr-2 h-4 w-4" /> Copiar código do favorito
            </Button>
            <div className="rounded-lg bg-slate-50 p-3 text-xs">
              <b className="text-[#0A1B6B]">Como usar:</b> no parceiro, clique em <b>Preencher no banco</b>. O link do banco
              abre numa nova aba. Espere carregar e clique no favorito <b>Preencher BB</b>. Os dados e documentos entram
              sozinhos. Confira e clique em <b>Enviar</b> no site do banco.
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
